export const routesEnvanter = [
  {
    path: "/envanter",
    name: "envanter",
    component: () => import("@/views/envanter/index.vue"),
    meta: {
      public: false,
      title: "Envanter",
      yetki: { k: [] },
    },
  },
  {
    path: "/envanter/kod",
    name: "envanter_kod",
    component: () => import("@/views/envanter/envanter_kod/index.vue"),
    meta: {
      public: false,
      title: "Envanter Kod Tanımlama",
      yetki: { k: [],a:true },
    },
  },
  {
    path: "/envanter/:uuid",
    name: "envanter_detay",
    component: () => import("@/views/envanter/profil/index.vue"),
    meta: {
      public: false,
      title: "Envanter Detay",
      yetki: { k: [] },
    },
  },
  {
    path: "/envanter/rapor",
    name: "envanter_rapor",
    component: () => import("@/views/envanter/envanter_rapor.vue"),
    meta: {
      public: false,
      title: "Envanter Raporu",
      yetki: { k: [] },
    },
  },
]
